import React from 'react';
import { Card, Container, Grid } from '@mui/material';

import Header from '../components/Header';
import CountersSection from '../components/CountersSection';
import InfoSection from '../components/InfoSection';
import SectionWithBackground from '../components/SectionWithBackground';
import FilledInfoCard from '../components/FilledInfoCard';
import {
    Flag as FlagIcon,
    PrecisionManufacturing as PrecisionManufacturingIcon,
    Apps as AppsIcon,
} from '@mui/icons-material';
import SectionLarge from '../components/LargeSection';
import Footer from '../components/Footer';

function Home() {
    return (
        <>
            <Header />
            <Card
                sx={{
                    p: 2,
                    mx: { xs: 2, lg: 3 },
                    mt: -8,
                    mb: 4,
                }}
            >
                <CountersSection />
                <InfoSection />
                <Container sx={{ mt: 6 }}>
                    <SectionWithBackground />
                </Container>
                <Container>
                    <Grid container spacing={3}>
                        <Grid item xs={12} lg={4}>
                            <FilledInfoCard
                                variant='gradient'
                                color='info'
                                icon={<FlagIcon />}
                                title='Getting Started'
                                description='Incididunt adipisicing incididunt cupidatat aute occaecat ad nisi labore nostrud officia. Deserunt minim reprehenderit non.'
                                action={{
                                    type: 'external',
                                    route: '#',
                                    label: "Let's start",
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} lg={4}>
                            <FilledInfoCard
                                icon={<PrecisionManufacturingIcon />}
                                title='Plugins'
                                description='Laborum commodo nulla nulla fugiat cupidatat laboris sunt incididunt consectetur cillum eu esse dolor nostrud.'
                                action={{
                                    type: 'external',
                                    route: '#',
                                    label: 'Read more',
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} lg={4}>
                            <FilledInfoCard
                                icon={<AppsIcon />}
                                title='Components'
                                description='Deserunt magna tempor cupidatat aliqua sint velit anim adipisicing veniam non aute.Id aliquip tempor.'
                                action={{
                                    type: 'external',
                                    route: '#',
                                    label: 'Go see',
                                }}
                            />
                        </Grid>
                    </Grid>
                </Container>
                <SectionLarge />
            </Card>
            <Footer />
        </>
    );
}

export default Home;
